import React, { useState } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography
} from '@mui/material';
import { Machine } from '../../../../ts/Connections';
import { AprilTag } from '../../../../ts/AprilTag';
import { useTranslation } from 'react-i18next';

interface SelectForkliftModalProps {
    open: boolean;
    setOpenForkliftModal: React.Dispatch<React.SetStateAction<boolean>>;
    forkliftList?: AprilTag[];
    setForklift?: React.Dispatch<React.SetStateAction<AprilTag | null>>;
    machine: Machine
}

const SelectForkliftModal: React.FC<SelectForkliftModalProps> = ({
    open,
    setOpenForkliftModal,
    forkliftList = [],
    setForklift,
    machine
}) => {
    const [selectedForklift, setSelectedForklift] = useState<string>('');
    const { t } = useTranslation();

    const handleChange = (event: SelectChangeEvent<string>) => {
        setSelectedForklift(event.target.value);
    };

    const handleSave = () => {
        if (setForklift) {
            if (selectedForklift === "") {
                setForklift(null);
            } else {
                const selectedForkliftObj = forkliftList.find(f => f.tagName === selectedForklift);
                if (selectedForkliftObj) {
                    setForklift(selectedForkliftObj);
                }
            }
            setOpenForkliftModal(false);
        }
    };

    const handleClose = () => {
        setOpenForkliftModal(false);
        setSelectedForklift('');
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t('control.inputs.selectForkliftModal.title')}</DialogTitle>
            <DialogContent>
                <FormControl fullWidth margin="normal">
                    <InputLabel id="forklift-select-label">{t('control.inputs.selectForkliftModal.forkLift')}</InputLabel>
                    <Select
                        labelId="forklift-select-label"
                        id="forklift-select"
                        value={selectedForklift}
                        onChange={handleChange}
                        label="Forklift"
                    >
                        <MenuItem value="">
                            {t('control.inputs.selectForkliftModal.noForklift')}
                        </MenuItem>
                        {forkliftList.length > 0 ? (
                            forkliftList.map((name, index) => (
                                <MenuItem key={index} value={name.tagName}>
                                    {name.tagName}
                                </MenuItem>
                            ))
                        ) : (
                            ""
                        )}
                    </Select>
                </FormControl>
                {
                    !machine.location ? 
                    <Box mt={2}>
                        <Typography variant="body2" color="warning.main">
                            {t('control.inputs.selectForkliftModal.warning')}
                        </Typography>
                    </Box>
                    :
                    ""
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    {t('control.inputs.selectForkliftModal.cancel')}
                </Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                    variant="contained"
                    disabled={false}
                >
                    {t('control.inputs.selectForkliftModal.save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SelectForkliftModal;